import type { InitialStateType } from './types';

const reducers = {
  maintenanceModeDetected: (state: InitialStateType) => {
    state.isActive = true;
  },

  maintenanceModeCleared: (state: InitialStateType) => {
    state.isActive = false;
  },
};

export default reducers;
